import apiService from '../../services/api';

const FetchUserDetails = async () => {
  try {
    const token = localStorage.getItem('access_token');
    if (!token) {
      console.error('No access token found');
      return false;
    }

    const response = await apiService.fetchData('user_details', token);
    
    console.log("Fetched User Data Successfully",response);
    
    // Store user details in session storage
    sessionStorage.setItem('user_name', response.user.Name);
    sessionStorage.setItem('user_emailId', response.user.EmailID);
    sessionStorage.setItem('user_id', response.user.ID);
    sessionStorage.setItem('practice_id', response.user.PracticeId);
    sessionStorage.setItem('image_url',response.user.ProfileImageURL)
    sessionStorage.setItem('module_access', JSON.stringify(response.moduleAccess)); 
    sessionStorage.setItem('user_role',response.role.RoleID);
    
    return true; 
  } catch (error) {
    console.error('Error fetching user data:', error);
    return false; 
  }
};
export default FetchUserDetails;
